import { asset } from "../assetUrl.js";

// AUTO-GENERATED asset manifests.
// NOTE when regenerating: source folders mix .jpg and .JPG, and one drawing was
// named "1C.D2.0.120..JPG" (double dot). Match case-insensitively and strip a
// trailing dot, or files are silently missed.

const DRAWING_IDS = new Set(["1C.C1.0.100", "1C.C1.0.120", "1C.C1.0.80", "1C.C2.S2.180", "1C.D1.S1.100", "1C.D1.S1.120", "1C.D1.S1.80", "1C.D2.0.100", "1C.D2.0.120", "1C.D2.0.80", "1C.D2.S2.180", "1C.D4.0.180", "1C.D4.S2.180", "1C.U1.100", "1C.U1.120", "1C.U1.180", "1C.U1.80", "1C.U1A.180", "1C.U2.100", "1C.U2.120", "1C.U2.180", "1C.U2.80", "1C.U2A.180", "1S.C1.0.100", "1S.C1.0.120", "1S.C1.0.80", "1S.D1.S1.100", "1S.D1.S1.120", "1S.D1.S1.80", "1S.D2.0.100", "1S.D2.0.120", "1S.D2.0.80", "1S.D2.S2.180", "1S.D4.0.180", "1S.U1.100", "1S.U1.120", "1S.U1.80", "1S.U1A.180", "1S.U2.100", "1S.U2.120", "1S.U2.80", "1S.U2A.180", "2C.D1.0.80", "2C.D2.0.100", "2C.D2.0.120", "2C.D3.0.180", "2C.U1.180", "2C.U2.180", "2S.U1.180", "2S.U2.180", "3C.0.0.100", "3C.0.0.120", "3C.0.0.180", "3C.0.0.80"]);

export function hasDrawing(item) {
  return !!item && DRAWING_IDS.has(item.id);
}

export function drawingFor(item) {
  return hasDrawing(item) ? asset(`/images/vanity/drawings/${item.id}.jpg`) : null;
}

// Gallery photos per article number.
// The supplied gallery folders each contained a copy of that SKU's technical
// drawing as well; those were removed (client request) - 54 dropped, 162 photos
// remain, every SKU still has at least 2.
const GALLERY = {
"1C.U1.100": [
"/images/vanity/inspirations/1C.U1.100/1.jpg",
"/images/vanity/inspirations/1C.U1.100/2.jpg",
"/images/vanity/inspirations/1C.U1.100/3.jpg",
"/images/vanity/inspirations/1C.U1.100/4.jpg"
],
"1C.U1.120": [
"/images/vanity/inspirations/1C.U1.120/1.jpg",
"/images/vanity/inspirations/1C.U1.120/2.jpg",
"/images/vanity/inspirations/1C.U1.120/3.jpg",
"/images/vanity/inspirations/1C.U1.120/4.jpg"
],
"1C.U1.180": [
"/images/vanity/inspirations/1C.U1.180/1.jpg",
"/images/vanity/inspirations/1C.U1.180/2.jpg",
"/images/vanity/inspirations/1C.U1.180/3.jpg",
"/images/vanity/inspirations/1C.U1.180/4.jpg"
],
"1C.U1.80": [
"/images/vanity/inspirations/1C.U1.80/1.jpg",
"/images/vanity/inspirations/1C.U1.80/2.jpg",
"/images/vanity/inspirations/1C.U1.80/3.jpg",
"/images/vanity/inspirations/1C.U1.80/4.jpg"
],
"1C.U1A.180": [
"/images/vanity/inspirations/1C.U1A.180/1.jpg",
"/images/vanity/inspirations/1C.U1A.180/2.jpg",
"/images/vanity/inspirations/1C.U1A.180/3.jpg",
"/images/vanity/inspirations/1C.U1A.180/4.jpg"
],
"1C.U2.100": [
"/images/vanity/inspirations/1C.U2.100/1.jpg",
"/images/vanity/inspirations/1C.U2.100/2.jpg",
"/images/vanity/inspirations/1C.U2.100/3.jpg",
"/images/vanity/inspirations/1C.U2.100/4.jpg"
],
"1C.U2.120": [
"/images/vanity/inspirations/1C.U2.120/1.jpg",
"/images/vanity/inspirations/1C.U2.120/2.jpg",
"/images/vanity/inspirations/1C.U2.120/3.jpg",
"/images/vanity/inspirations/1C.U2.120/4.jpg"
],
"1C.U2.180": [
"/images/vanity/inspirations/1C.U2.180/1.jpg",
"/images/vanity/inspirations/1C.U2.180/2.jpg",
"/images/vanity/inspirations/1C.U2.180/3.jpg",
"/images/vanity/inspirations/1C.U2.180/4.jpg"
],
"1C.U2.80": [
"/images/vanity/inspirations/1C.U2.80/1.jpg",
"/images/vanity/inspirations/1C.U2.80/2.jpg",
"/images/vanity/inspirations/1C.U2.80/3.jpg",
"/images/vanity/inspirations/1C.U2.80/4.jpg"
],
"1C.U2A.180": [
"/images/vanity/inspirations/1C.U2A.180/1.jpg",
"/images/vanity/inspirations/1C.U2A.180/2.jpg",
"/images/vanity/inspirations/1C.U2A.180/3.jpg",
"/images/vanity/inspirations/1C.U2A.180/4.jpg"
],
"2C.U1.180": [
"/images/vanity/inspirations/2C.U1.180/1.jpg",
"/images/vanity/inspirations/2C.U1.180/2.jpg",
"/images/vanity/inspirations/2C.U1.180/3.jpg",
"/images/vanity/inspirations/2C.U1.180/4.jpg"
],
"2C.U2.180": [
"/images/vanity/inspirations/2C.U2.180/1.jpg",
"/images/vanity/inspirations/2C.U2.180/2.jpg",
"/images/vanity/inspirations/2C.U2.180/3.jpg",
"/images/vanity/inspirations/2C.U2.180/4.jpg"
],
"1S.U1.100": [
"/images/vanity/inspirations/1S.U1.100/1.jpg",
"/images/vanity/inspirations/1S.U1.100/2.jpg",
"/images/vanity/inspirations/1S.U1.100/3.jpg",
"/images/vanity/inspirations/1S.U1.100/4.jpg",
"/images/vanity/inspirations/1S.U1.100/5.jpg"
],
"1S.U1.120": [
"/images/vanity/inspirations/1S.U1.120/1.jpg",
"/images/vanity/inspirations/1S.U1.120/2.jpg",
"/images/vanity/inspirations/1S.U1.120/3.jpg",
"/images/vanity/inspirations/1S.U1.120/4.jpg",
"/images/vanity/inspirations/1S.U1.120/5.jpg"
],
"1S.U1.80": [
"/images/vanity/inspirations/1S.U1.80/1.jpg",
"/images/vanity/inspirations/1S.U1.80/2.jpg",
"/images/vanity/inspirations/1S.U1.80/3.jpg",
"/images/vanity/inspirations/1S.U1.80/4.jpg",
"/images/vanity/inspirations/1S.U1.80/5.jpg"
],
"1S.U1A.180": [
"/images/vanity/inspirations/1S.U1A.180/1.jpg",
"/images/vanity/inspirations/1S.U1A.180/2.jpg",
"/images/vanity/inspirations/1S.U1A.180/3.jpg",
"/images/vanity/inspirations/1S.U1A.180/4.jpg",
"/images/vanity/inspirations/1S.U1A.180/5.jpg"
],
"1S.U2.100": [
"/images/vanity/inspirations/1S.U2.100/1.jpg",
"/images/vanity/inspirations/1S.U2.100/2.jpg",
"/images/vanity/inspirations/1S.U2.100/3.jpg",
"/images/vanity/inspirations/1S.U2.100/4.jpg",
"/images/vanity/inspirations/1S.U2.100/5.jpg"
],
"1S.U2.120": [
"/images/vanity/inspirations/1S.U2.120/1.jpg",
"/images/vanity/inspirations/1S.U2.120/2.jpg",
"/images/vanity/inspirations/1S.U2.120/3.jpg",
"/images/vanity/inspirations/1S.U2.120/4.jpg",
"/images/vanity/inspirations/1S.U2.120/5.jpg"
],
"1S.U2.80": [
"/images/vanity/inspirations/1S.U2.80/1.jpg",
"/images/vanity/inspirations/1S.U2.80/2.jpg",
"/images/vanity/inspirations/1S.U2.80/3.jpg",
"/images/vanity/inspirations/1S.U2.80/4.jpg",
"/images/vanity/inspirations/1S.U2.80/5.jpg"
],
"1S.U2A.180": [
"/images/vanity/inspirations/1S.U2A.180/1.jpg",
"/images/vanity/inspirations/1S.U2A.180/2.jpg",
"/images/vanity/inspirations/1S.U2A.180/3.jpg",
"/images/vanity/inspirations/1S.U2A.180/4.jpg",
"/images/vanity/inspirations/1S.U2A.180/5.jpg"
],
"2S.U1.180": [
"/images/vanity/inspirations/2S.U1.180/1.jpg",
"/images/vanity/inspirations/2S.U1.180/2.jpg",
"/images/vanity/inspirations/2S.U1.180/3.jpg",
"/images/vanity/inspirations/2S.U1.180/4.jpg",
"/images/vanity/inspirations/2S.U1.180/5.jpg"
],
"2S.U2.180": [
"/images/vanity/inspirations/2S.U2.180/1.jpg",
"/images/vanity/inspirations/2S.U2.180/2.jpg",
"/images/vanity/inspirations/2S.U2.180/3.jpg",
"/images/vanity/inspirations/2S.U2.180/4.jpg",
"/images/vanity/inspirations/2S.U2.180/5.jpg"
],
"1C.C1.0.100": [
"/images/vanity/inspirations/1C.C1.0.100/1.jpg",
"/images/vanity/inspirations/1C.C1.0.100/2.jpg"
],
"1C.C1.0.120": [
"/images/vanity/inspirations/1C.C1.0.120/1.jpg",
"/images/vanity/inspirations/1C.C1.0.120/2.jpg"
],
"1C.C1.0.80": [
"/images/vanity/inspirations/1C.C1.0.80/1.jpg",
"/images/vanity/inspirations/1C.C1.0.80/2.jpg"
],
"1C.C2.S2.180": [
"/images/vanity/inspirations/1C.C2.S2.180/1.jpg",
"/images/vanity/inspirations/1C.C2.S2.180/2.jpg"
],
"1C.D1.S1.100": [
"/images/vanity/inspirations/1C.D1.S1.100/1.jpg",
"/images/vanity/inspirations/1C.D1.S1.100/2.jpg"
],
"1C.D1.S1.120": [
"/images/vanity/inspirations/1C.D1.S1.120/1.jpg",
"/images/vanity/inspirations/1C.D1.S1.120/2.jpg"
],
"1C.D1.S1.80": [
"/images/vanity/inspirations/1C.D1.S1.80/1.jpg",
"/images/vanity/inspirations/1C.D1.S1.80/2.jpg"
],
"1C.D2.0.100": [
"/images/vanity/inspirations/1C.D2.0.100/1.jpg",
"/images/vanity/inspirations/1C.D2.0.100/2.jpg"
],
"1C.D2.0.120": [
"/images/vanity/inspirations/1C.D2.0.120/1.jpg",
"/images/vanity/inspirations/1C.D2.0.120/2.jpg"
],
"1C.D2.0.80": [
"/images/vanity/inspirations/1C.D2.0.80/1.jpg",
"/images/vanity/inspirations/1C.D2.0.80/2.jpg"
],
"1C.D2.S2.180": [
"/images/vanity/inspirations/1C.D2.S2.180/1.jpg",
"/images/vanity/inspirations/1C.D2.S2.180/2.jpg"
],
"1C.D4.0.180": [
"/images/vanity/inspirations/1C.D4.0.180/1.jpg",
"/images/vanity/inspirations/1C.D4.0.180/2.jpg"
],
"1C.D4.S2.180": [
"/images/vanity/inspirations/1C.D4.S2.180/1.jpg",
"/images/vanity/inspirations/1C.D4.S2.180/2.jpg"
],
"2C.D1.0.80": [
"/images/vanity/inspirations/2C.D1.0.80/1.jpg",
"/images/vanity/inspirations/2C.D1.0.80/2.jpg"
],
"2C.D2.0.100": [
"/images/vanity/inspirations/2C.D2.0.100/1.jpg",
"/images/vanity/inspirations/2C.D2.0.100/2.jpg"
],
"2C.D2.0.120": [
"/images/vanity/inspirations/2C.D2.0.120/1.jpg",
"/images/vanity/inspirations/2C.D2.0.120/2.jpg"
],
"2C.D3.0.180": [
"/images/vanity/inspirations/2C.D3.0.180/1.jpg",
"/images/vanity/inspirations/2C.D3.0.180/2.jpg"
],
"3C.0.0.100": [
"/images/vanity/inspirations/3C.0.0.100/1.jpg",
"/images/vanity/inspirations/3C.0.0.100/2.jpg"
],
"3C.0.0.120": [
"/images/vanity/inspirations/3C.0.0.120/1.jpg",
"/images/vanity/inspirations/3C.0.0.120/2.jpg"
],
"3C.0.0.180": [
"/images/vanity/inspirations/3C.0.0.180/1.jpg",
"/images/vanity/inspirations/3C.0.0.180/2.jpg"
],
"3C.0.0.80": [
"/images/vanity/inspirations/3C.0.0.80/1.jpg",
"/images/vanity/inspirations/3C.0.0.80/2.jpg"
],
"1S.C1.0.100": [
"/images/vanity/inspirations/1S.C1.0.100/1.jpg",
"/images/vanity/inspirations/1S.C1.0.100/2.jpg"
],
"1S.C1.0.120": [
"/images/vanity/inspirations/1S.C1.0.120/1.jpg",
"/images/vanity/inspirations/1S.C1.0.120/2.jpg"
],
"1S.C1.0.80": [
"/images/vanity/inspirations/1S.C1.0.80/1.jpg",
"/images/vanity/inspirations/1S.C1.0.80/2.jpg"
],
"1S.D1.S1.100": [
"/images/vanity/inspirations/1S.D1.S1.100/1.jpg",
"/images/vanity/inspirations/1S.D1.S1.100/2.jpg"
],
"1S.D1.S1.120": [
"/images/vanity/inspirations/1S.D1.S1.120/1.jpg",
"/images/vanity/inspirations/1S.D1.S1.120/2.jpg"
],
"1S.D1.S1.80": [
"/images/vanity/inspirations/1S.D1.S1.80/1.jpg",
"/images/vanity/inspirations/1S.D1.S1.80/2.jpg"
],
"1S.D2.0.100": [
"/images/vanity/inspirations/1S.D2.0.100/1.jpg",
"/images/vanity/inspirations/1S.D2.0.100/2.jpg"
],
"1S.D2.0.120": [
"/images/vanity/inspirations/1S.D2.0.120/1.jpg",
"/images/vanity/inspirations/1S.D2.0.120/2.jpg"
],
"1S.D2.0.80": [
"/images/vanity/inspirations/1S.D2.0.80/1.jpg",
"/images/vanity/inspirations/1S.D2.0.80/2.jpg"
],
"1S.D2.S2.180": [
"/images/vanity/inspirations/1S.D2.S2.180/1.jpg",
"/images/vanity/inspirations/1S.D2.S2.180/2.jpg"
],
"1S.D4.0.180": [
"/images/vanity/inspirations/1S.D4.0.180/1.jpg",
"/images/vanity/inspirations/1S.D4.0.180/2.jpg"
]
};

export function galleryFor(item) {
  if (!item) return [];
  return (GALLERY[item.id] || []).map(asset);
}
